import PathType from "../../../consts/pathmodule/PathType";
import { IJobResumeDto } from "./IJobResumeDto";

export default class PathAIJobResumeDto extends IJobResumeDto {
	RowCount: number;
	constructor(
		rowCount: number) {
		super(PathType.AI);
		this.RowCount = rowCount;
	}
}